module.exports = __webpack_public_path__ + "img/Lampion_boule_papier.443e4a3.jpg";